export const parseBoolean = (property: unknown): boolean => {
  const propertyAsString = `${property}`.toLocaleLowerCase()
  if (propertyAsString.length > 0 && (propertyAsString === 'true' || propertyAsString === '1'))
    return true
  return false
}
